import Search16 from '@carbon/icons-react/es/search/16';
import { useBoolean, useClickAway } from 'ahooks';
import { Typography } from 'antd';
import React, { FC, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { components } from 'react-select';
import styled from 'styled-components';
import { Select, UserTag as UserTagSelect } from 'components/atoms/select';
import { Option } from 'components/atoms/select/types';
import {
  Popover,
  SelectContainer,
} from 'components/molecules/new-task-modal/styled';

const UserTag = styled(UserTagSelect)`
  overflow: hidden;
  width: 100%;
`;
const ControlComponent = (props) => <components.Control {...props} />;
const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <Search16 />
    </components.DropdownIndicator>
  );
};
const StyledMenu = styled(components.Menu)`
  box-shadow: none;
`;
const Menu = (props) => {
  return <StyledMenu {...props} />;
};

interface ProjectSelectProps {
  onChange: (value) => void;
  options: Option[];
  selected: Option | null | undefined;
  disabled?: boolean;
}

export const ProjectSelect: FC<ProjectSelectProps> = ({
  onChange,
  options,
  selected,
  disabled,
}) => {
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const [visible, { toggle, setFalse }] = useBoolean(false);

  useClickAway(() => {
    if (visible) {
      toggle();
    }
  }, [ref1, ref2]);

  const handleChange = (latest: Option | undefined | null) => {
    setFalse();
    onChange(latest);
  };

  return (
    <Popover
      placement="bottomLeft"
      visible={visible}
      destroyTooltipOnHide
      content={
        <SelectContainer ref={ref1}>
          <Select
            className="project-select"
            type="user"
            menuIsOpen
            autoFocus
            controlShouldRenderValue={false}
            components={{
              Control: ControlComponent,
              DropdownIndicator,
              Menu,
              IndicatorSeparator: () => null,
            }}
            placeholder={<FormattedMessage id="placeholder.search" />}
            options={options}
            onChange={handleChange}
            onBlur={setFalse}
            selected={selected}
          />
        </SelectContainer>
      }
      trigger="click"
    >
      <Typography.Link
        data-cy="card.create-task.project"
        ref={ref2}
        onClick={() => toggle()}
        disabled={disabled}
      >
        {selected ? (
          <UserTag imageUrl={selected.imageUrl} label={selected.label} />
        ) : (
          <FormattedMessage id="choose" />
        )}
      </Typography.Link>
    </Popover>
  );
};
